<h1 *ngIf="!mobile"
    mat-dialog-title
    id="permit-request-dialog-header">
    {{ 'default.permitRequest.header' | blah }} {{ permitIdentifier }}
</h1>


<div *ngIf="initializing">
    <hpo-placeholder type="row"></hpo-placeholder>
    <hpo-placeholder type="input"
        [rows]="7"></hpo-placeholder>
</div>

<div *ngIf="!initializing">
    <div>
        <div id="permit-request-status">Lupahakemuksen tila: {{ permitStatus ? permitStatus : ('default.UnSent' | blah) }} </div>
        <div id="permit-request-data-fetched">Luvan tiedot noudettu: {{ permitDataFetched ? (permitDataFetched | date:'d.M.y H:mm') :
            ('default.UnSent' | blah) }}</div>
    </div>


    <div>
        <div class="history-container">
            <div>{{ 'default.permitRequest.sendHistory' | blah:[5] }}:</div>
            <div class="history-entries">

                <div *ngFor="let item of externalRequests; let i = index">
                    <ng-container [ngSwitch]="item.RequestState">
                        <mat-icon *ngSwitchCase="'InProgress'"
                            class="in-progress"
                            matTooltip="{{ 'default.externalRequest.requestInProgress' | blah }}"
                            matTooltipPosition="right"
                            matTooltipClass="hpo">refresh</mat-icon>
                        <mat-icon *ngSwitchCase="'Completed'"
                            class="completed"
                            matTooltip="{{ 'default.externalRequest.requestCompleted' | blah }}"
                            matTooltipPosition="right"
                            matTooltipClass="hpo">check_circle_outlined</mat-icon>
                        <mat-icon *ngSwitchCase="'Failed'"
                            class="failed"
                            (mouseover)="getFailedExternalRequestMessage(item)"
                            matTooltip="{{ failedTooltipMessage }}"
                            matTooltipPosition="right"
                            matTooltipClass="hpo">cancel_outlined</mat-icon>
                    </ng-container>
                    <div [id]="'history-entry-' + i ">
                        {{ item.RequestCreated | date:'d.M.yyyy H:mm' }} {{item.RequesterName}}, {{ item.CompanyName }} ({{
                        ('default.permitRequest.events.' + item.RequestDescription) | blah
                        }})
                    </div>
                </div>

                <i *ngIf="externalRequests.length === 0">
                    {{ 'default.permitRequest.noPreviousSends' | blah }}
                </i>

            </div>
        </div>
    </div>



</div>

<mat-dialog-actions align="end"
    class="request-actions">

    <button id="cancel-button"
        mat-stroked-button
        mat-dialog-close>
        {{ 'default.close' | blah | uppercase }}
    </button>

    <hpo-split-button *ngIf="primaryAllowedRequestType"
        id="actions-split-button"
        buttonStyle="stroked"
        color="primary">

        <hpo-button-item [id]="primaryAllowedRequestType +'-primary-action-button'"
            primary
            [disabled]="initializing || submitting"
            (click)="submit(primaryAllowedRequestType)">
            <mat-icon>send</mat-icon>
            {{ ('default.permitRequest.events.' + primaryAllowedRequestType) | blah | uppercase }}
        </hpo-button-item>

        <hpo-button-item *ngFor="let requestType of secondaryAllowedRequestTypes; let i = index"
            [id]="requestType +'-secondary-action-button'"
            [disabled]="initializing || submitting"
            (click)="submit(requestType)">
            <mat-icon>send</mat-icon>
            {{ ('default.permitRequest.events.' + requestType) | blah | uppercase }}
        </hpo-button-item>

    </hpo-split-button>

</mat-dialog-actions>